<h2 mat-dialog-title>{{ dialogData.title }}</h2>

<mat-dialog-content>
  {{ dialogData.text }}
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close color="primary">OK</button>
</mat-dialog-actions>
